import { makeThemeStyle } from './makeThemeStyle';

export const useButtonStyles = makeThemeStyle(theme => ({
  normalButton: {
    backgroundColor: '#fff',
    color: '#002743',
    paddingLeft: 16,
    paddingRight: 16,
    border: `1px solid #c1c6c8`,
    boxShadow:
      '0px 4px 4px -4px rgba(0,0,0,0.1), 0px 8px 5px -4px rgba(0,0,0,0.07),0px 10px 10px -6px rgba(0,0,0,0.06)',
    '&:hover': {
      backgroundColor: '#d0d3d4',
    },
    '&.Mui-disabled': { opacity: 0.4 },
  },
  warningButton: {
    backgroundColor: '#fff',
    color: '#D51D1D',
    paddingLeft: 16,
    paddingRight: 16,
    border: `1px solid #D51D1D`,
    '&:hover': {
      backgroundColor: '#eeeeee',
    },
    '&.Mui-disabled': { opacity: 0.4, border: 'none' },
  },
  roundButton: {
    borderRadius: 999,
  },
}));
